<template>
  <Modal @close="close">
    <template v-slot:body>
      <div class="validation-wrapper">
        <b-icon icon="lock" class="validation-icon" type="is-white"> </b-icon>

        <h3 class="validation-title">{{ info.title }}</h3>

        <p class="validation-text">{{ info.text }}</p>

        <span class="validation-email">
          {{ info.email }}
        </span>
      </div>
    </template>
    <template v-slot:footer>
      <b-button
        type="is-primary"
        @click.prevent="confirm"
        class="validation-button"
        >{{ info.actionLabel }}</b-button
      >
    </template>
  </Modal>
</template>

<script>
import Modal from "../layout/Modal";

export default {
  name: "AccessValidation",
  components: {
    Modal,
  },
  props: ["info"],
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="scss">
.validation-wrapper {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  gap: 20px;
}

.validation-icon {
  width: 80px;
  height: 80px;
  margin-top: 15px;

  svg {
    width: 80px;
    height: 80px;
    color: #09b6f3;
  }
}

.validation-title {
  font-size: 21px;
  font-weight: 700;
}

.validation-text {
  font-size: 18px;
  font-weight: 700;
  color: #9b9b9b;
  width: 250px;
  text-align: center;
}

.validation-email {
  font-size: 18px;
  font-weight: 700;
  color: #09b6f3;
}

.validation-button {
  height: 50px;
  border-radius: 50px;
  width: 200px;
  display: inline-flex;
  font-weight: 700;
  margin: 0 auto 15px;
}
</style>
